export default __webpack_public_path__ + "static/media/spread-love.1ae5b849.svg";